module.exports = __webpack_public_path__ + "static/media/logo.1224a0f8.png";